/* Popup de video da pagina do produto. Ver popup.js em
 * Developer\klarcar-loja para o contexto. */
(function () {
  var raiz = document.querySelector('[data-kc-vid]');
  if (!raiz) return;
  var video = raiz.querySelector('[data-kc-vid-video]');
  var caixa = raiz.querySelector('.kc-vid__caixa');
  var CHAVE = 'kc_video_fechado';
  var ATRASO = 4000;   // deixa a pagina carregar antes de disputar atencao

  try { if (sessionStorage.getItem(CHAVE)) return; } catch (e) {}

  // O bloco nasce dentro de .product__info-wrapper, que o tema anima com
  // transform. Um transform - mesmo o de identidade que a animacao deixa para
  // tras - cria containing block, e position:fixed passa a se medir por ele:
  // o popup ia parar no meio da pagina, 500px abaixo da tela. Subir para o
  // body resolve na raiz.
  if (raiz.parentElement !== document.body) document.body.appendChild(raiz);

  function estado(v) { raiz.setAttribute('data-estado', v); }

  function mostra() {
    estado('canto');
    video.muted = true;              // autoplay com som e bloqueado
    video.play().catch(function () {});
  }

  function som(ligado) {
    video.muted = !ligado;
    raiz.setAttribute('data-som', ligado ? 'on' : 'off');
    if (ligado) video.play().catch(function () {});
  }

  function fecha() {
    estado('oculto');
    video.pause();
    try { sessionStorage.setItem(CHAVE, '1'); } catch (e) {}
  }

  function centro() {
    if (raiz.getAttribute('data-estado') === 'centro') return;
    estado('centro');
    som(true);                       // quem clicou quer assistir, nao espiar
    document.body.style.overflow = 'hidden';
  }

  function canto() {
    estado('canto');
    document.body.style.overflow = '';
  }

  caixa.addEventListener('click', function (e) {
    if (e.target.closest('[data-kc-vid-fechar]') || e.target.closest('[data-kc-vid-som]')) return;
    centro();
  });
  raiz.querySelector('[data-kc-vid-fechar]').addEventListener('click', function (e) {
    e.stopPropagation();
    // no centro o X volta para o canto; no canto ele fecha de vez
    if (raiz.getAttribute('data-estado') === 'centro') canto(); else fecha();
  });
  raiz.querySelector('[data-kc-vid-som]').addEventListener('click', function (e) {
    e.stopPropagation();
    som(video.muted);
  });
  raiz.querySelector('[data-kc-vid-fundo]').addEventListener('click', canto);
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && raiz.getAttribute('data-estado') === 'centro') canto();
  });

  setTimeout(mostra, ATRASO);
})();
